import { ColumnDef } from '@tanstack/react-table';
import { Link, useParams } from 'react-router';

import { GetNoticesResponseDto } from '../../../dtos/responses/get-notices.response.dto';
import { formatDate } from '../../../lib/date';

export const NOTICE_COLUMNS: ColumnDef<GetNoticesResponseDto>[] = [
  {
    accessorKey: 'title',
    header: '제목',
    cell: ({ row }) => <NoticeLink title={row.original.title} id={row.original.id} />,
    meta: { className: 'w-[60%]' },
  },
  {
    accessorKey: 'creator',
    header: '작성자',
    cell: ({ row }) => <div className="text-left">{row.original.creator.name}</div>,
    meta: { className: 'w-[20%]' },
  },
  {
    accessorKey: 'createdAt',
    header: '게시일시',
    cell: ({ row }) => <div>{formatDate(row.original.createdAt)}</div>,
    meta: { className: 'w-[20%]' },
  },
];

interface NoticeLinkProps {
  id: string;
  title: string;
}

const NoticeLink = (props: NoticeLinkProps) => {
  const { id, title } = props;
  const { courseId } = useParams<{ courseId: string }>();
  return (
    <Link
      className="underline underline-offset-2 text-[#0085ff] cursor-pointer"
      to={`/course/${courseId}/notice/${id}`}
    >
      {title}
    </Link>
  );
};
